import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'modules/root-reducer';

export default function configureStore(initialState) {
  console.log("configure from prod")
  return createStore(rootReducer, initialState, applyMiddleware(thunk));
}